import { GlTooltipDirective, GlButton } from '@gitlab/ui';
import { translate } from '../../../../../utils/i18n';
import { checkClipboardPermissions } from '../../duo_chat_message/utils';
import { highlightElement } from '../services/highlight';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'PreBlock',
  directives: {
    GlTooltip: GlTooltipDirective
  },
  components: {
    GlButton
  },
  props: {
    language: {
      type: String,
      required: false,
      default: 'plaintext'
    }
  },
  async mounted() {
    await this.$nextTick();
    this.applyHighlight();
  },
  methods: {
    async applyHighlight() {
      try {
        const codeElement = this.$el.querySelector('code');
        if (codeElement) {
          highlightElement(codeElement);
        }
      } catch (error) {
        // Silently fail if highlight.js is not available
        // eslint-disable-next-line no-console
        console.warn('highlight.js could not be loaded:', error);
      }
    },
    async copyToClipboard() {
      try {
        const textToCopy = this.$refs.codeElement.textContent;
        const hasClipboardPermission = await checkClipboardPermissions();
        const event = new CustomEvent('copy-code-snippet', {
          bubbles: true,
          detail: {
            code: textToCopy
          }
        });
        // Emit custom event for VS Code and other environments
        // This bubbles up to parent components that handle clipboard operations
        this.$emit('copy-code-snippet', {
          detail: {
            code: textToCopy
          }
        });
        this.$el.dispatchEvent(event);

        // If we have clipboard permission, also copy directly
        if (hasClipboardPermission) {
          await navigator.clipboard.writeText(textToCopy);
        }
        this.$emit('copied', this.title);
        setTimeout(() => {
          this.$refs.copyToClipboardButton.$el.blur();
        }, 100);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Failed to copy:', e);
      }
    }
  },
  i18n: {
    COPY_TO_CLIPBOARD_TEXT: translate('PreBlock.COPY_TO_CLIPBOARD_TEXT', 'Copy to clipboard')
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{staticClass:"duo-message-pre-block code code-syntax-highlight-theme !focus:gl-focus gl-border !gl-relative gl-grid gl-max-h-48 gl-overflow-auto gl-whitespace-pre-wrap gl-text-pretty gl-rounded-lg gl-border-strong !gl-p-5 gl-font-monospace gl-text-strong",attrs:{"tabindex":"0"}},[_c('span',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.hover.focus.blur",modifiers:{"hover":true,"focus":true,"blur":true}}],staticClass:"copy-to-clipboard-button-container gl-inline-flex gl-absolute gl-right-5 gl-top-4 gl-z-1 gl-opacity-0 gl-transition-opacity",attrs:{"title":_vm.$options.i18n.COPY_TO_CLIPBOARD_TEXT}},[_vm._v("\n"),_c('gl-button',{ref:"copyToClipboardButton",attrs:{"icon":"copy-to-clipboard","aria-label":_vm.$options.i18n.COPY_TO_CLIPBOARD_TEXT},on:{"click":function($event){$event.stopPropagation();return _vm.copyToClipboard.apply(null, arguments)}}}),_vm._v("\n")],1),_vm._v("\n  \n"),_c('code',{ref:"codeElement",staticClass:"!gl-leading-20 gl-break-all",class:("language-" + _vm.language)},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
